import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Typography from '@mui/material/Typography';
import ContentCut from '@mui/icons-material/ContentCut';
import ContentCopy from '@mui/icons-material/ContentCopy';
import ContentPaste from '@mui/icons-material/ContentPaste';
import Cloud from '@mui/icons-material/Cloud';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/Divider": Divider, "@mui/material/Paper": Paper, "@mui/material/MenuList": MenuList, "@mui/material/MenuItem": MenuItem, "@mui/material/ListItemText": ListItemText, "@mui/material/ListItemIcon": ListItemIcon, "@mui/material/Typography": Typography, "@mui/icons-material/ContentCut": ContentCut, "@mui/icons-material/ContentCopy": ContentCopy, "@mui/icons-material/ContentPaste": ContentPaste, "@mui/icons-material/Cloud": Cloud } } });
export default ClientProvider;
